import { Path } from '@/types/global';
import { OneOffCheckRecord } from '@/types/turn-api';
import { OneOffCheckActionEnum } from '@/types/turn-enums';
import { FormFields } from './types';

export const STATUS_CHOICES = [
  { id: 'start_processing', name: 'processing' },
  { id: 'attention', name: 'attention' },
  { id: 'fulfilled', name: 'fulfilled' },
  { id: 'withdrawn', name: 'withdrawn' },
  { id: 'clear', name: 'clear' },
  { id: 'consider', name: 'consider' },
  { id: 'unsolved', name: 'unsolved' },
];

export const REQUIRES_PROOF: OneOffCheckRecord.Action[] = [
  OneOffCheckActionEnum.Clear,
  OneOffCheckActionEnum.Consider,
  OneOffCheckActionEnum.Fulfilled,
  OneOffCheckActionEnum.ToFulfilled,
  OneOffCheckActionEnum.Unsolved,
];

export const path = (path: Path<FormFields>) => path;

export const VALIDATION_RETRY_MESSAGE = 'The report could not be validated. Upload the PDF again to retry.';

export const OVERRIDE_DISABLED_TOOLTIP = 'Only admins can activate override action';

export const OVERRIDE_ERROR_MESSAGE = 'Error: Report validation was not overridden';
